// tracking add candidate
import { trackEvent } from '../../modules/events';

import { ADD_CANDIDATE_FORM_STEP } from '../../components/app/AddCandidate/types';
import type { AttachmentTypeName } from 'src/constants/attachmentTypes';

const EVENT_ADD_CANDIDATE_CLICKED = 'add_candidate_start_pressed';

const EDIT_EMAIL_CLICKED = 'add-candidate-edit-candidate-email';
const EDIT_CANDIDATE_DETAILS_CLICKED = 'add-candidate-edit-candidate-details';
const EDIT_CANDIDATE_EXPERIENCE_CLICKED =
  'add-candidate-edit-candidate-experience';

const ADD_CANDIDATE_CONTINUE_BTN_PRESSED = 'add_candidate_continue_btn_pressed';
const ADD_CANDIDATE_COMPLETE_BTN_PRESSED = 'add_candidate_complete_btn_pressed';
const ADD_CANDIDATE_STEP_1 = 'add candidate step1';
const ADD_CANDIDATE_STEP_2 = 'add candidate step2';
const ADD_CANDIDATE_STEP_3 = 'add candidate step3';
const ADD_CANDIDATE_STEP_4 = 'add candidate step4';

const CANCEL_CLICKED = 'add-candidate-cancel-btn-interacted';

const ADD_ATTACHMENT_CLICKED = 'add_candidate_add_document_pressed';

const REMOVE_ATTACHMENT_CLICKED = 'add_candidate_remove_document_pressed';

export const trackAddCandidateClickedEvent = (attributes = {}) =>
  trackEvent(EVENT_ADD_CANDIDATE_CLICKED, attributes);

export const trackEditEmailClickedEvent = (attributes = {}) =>
  trackEvent(EDIT_EMAIL_CLICKED, attributes);

export const trackEditCandidateDetailsClickedEvent = (attributes = {}) =>
  trackEvent(EDIT_CANDIDATE_DETAILS_CLICKED, attributes);

export const trackEditCandidateExperienceClickedEvent = (attributes = {}) =>
  trackEvent(EDIT_CANDIDATE_EXPERIENCE_CLICKED, attributes);

const EVENT_ADD_CANDIDATE_STEP_MAP = {
  [ADD_CANDIDATE_FORM_STEP.ONE]: ADD_CANDIDATE_STEP_1,
  [ADD_CANDIDATE_FORM_STEP.TWO]: ADD_CANDIDATE_STEP_2,
  [ADD_CANDIDATE_FORM_STEP.THREE]: ADD_CANDIDATE_STEP_3,
  [ADD_CANDIDATE_FORM_STEP.FOUR]: ADD_CANDIDATE_STEP_4,
};

export const trackContinueClickedEvent = (step: 1 | 2 | 3 | 4) => {
  const currentPage = EVENT_ADD_CANDIDATE_STEP_MAP[step];
  const addCandidateEvent =
    step === 4
      ? ADD_CANDIDATE_COMPLETE_BTN_PRESSED
      : ADD_CANDIDATE_CONTINUE_BTN_PRESSED;
  trackEvent(addCandidateEvent, { currentPage });
};

export const trackCancelClickedEvent = (attributes = {}) =>
  trackEvent(CANCEL_CLICKED, attributes);

export const trackAddAttachmentClickedEvent = (attributes: {
  documentType: AttachmentTypeName;
}) =>
  trackEvent(ADD_ATTACHMENT_CLICKED, {
    ...attributes,
    currentPage: ADD_CANDIDATE_STEP_4,
  });

export const trackRemoveAttachmentClickedEvent = (attributes: {
  documentType: AttachmentTypeName;
}) =>
  trackEvent(REMOVE_ATTACHMENT_CLICKED, {
    ...attributes,
    currentPage: ADD_CANDIDATE_STEP_4,
  });
